const Clanak = () => {
  return (
    <div className="clanak-page" id="clanak-page">
      <img
        src="/images/clanak.jpg"
        className="clanak-img"
        alt="ison background"
      />
    </div>
  );
};

export default Clanak;
